import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice.js';
import scanReducer from './scanSlice.js';
import checkConfigReducer from './checkConfigSlice.js';
import uiConfigReducer from './uiConfigSlice.js';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    scan: scanReducer,
    checkConfig: checkConfigReducer,
    uiConfig: uiConfigReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
